import { get } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';
import { SEARCH_LOAD_ERROR, SEARCH_RECEIVE, PaginationOptions} from '../../constants';


const firstHtml = document.querySelector('html');
const iso = firstHtml.getAttribute('lang');

export const fetchPopularSearch = () => (dispatch, getState) => {
    return get(`/api/search/${iso}`)
        .then((response) => response.json())
        .then((data) => dispatch(receive(data)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const fetchSuggestions = (iso, query) => (dispatch, getState) => {
    return get(`/api/suggestions/${iso}?q=${query}`)
        .then((response) => response.json())
        .then((data) => { return data })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const fetchSearch = (iso, query, currentPage = PaginationOptions.Page, showAllPages = false) => async (dispatch, getState) => {
    try {
        if (currentPage > 0) {
            currentPage--;
        }
        const response = await get(`/api/search/result/${iso}?q=${query}&page=${currentPage}&pageSize=${PaginationOptions.PageSize}&all=${showAllPages}`);
        const data = await response.json();
        return data;
    } catch (ex) {
        dispatch(catchError(ex, (error) => loadError(error)));
    }
};

export const loadError = (error) => ({
    type: SEARCH_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (searchData) => ({
    type: SEARCH_RECEIVE,
    payload: {
        searchData: searchData
    },
});